<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('staff_card')" :isColumns="true"
                    @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in datatable.columns" v-bind:key="key">
                            <b-form-checkbox v-model="column.hidden" :id="'checkbox-' + key" :name="'checkbox-' + key"
                                :value="false" :unchecked-value="true" v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('staff_card')" :isColumns="true"
                    @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in datatable.columns" v-bind:key="key">
                            <b-form-checkbox v-model="column.hidden" :id="'checkbox-' + key" :name="'checkbox-' + key"
                                :value="false" :unchecked-value="true" v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear"
                >
                <b-row>
                    <b-col sm="6">
                        <b-form-group :label="$t('faculty')">
                            <faculty-selectbox v-model="datatable.queryParams.filter.faculty_code" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group :label="$t('name')">
                            <b-form-input v-model="datatable.queryParams.filter.name" type="text" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group :label="$t('program')">
                            <program-selectbox v-model="datatable.queryParams.filter.program_code" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group :label="$t('surname')">
                            <b-form-input v-model="datatable.queryParams.filter.surname" type="text" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group :label="$t('card_status')">
                            <StudentCardStatusSelectbox v-model="datatable.queryParams.filter.card_status" />
                        </b-form-group>
                    </b-col>

                </b-row>
            </datatable-filter>
            <datatable v-show="datatable.showTable" :isLoading="datatable.isLoading" :rows="datatable.rows"
                :columns="datatable.columns" :query-params="datatable.queryParams" :total="datatable.total"
                @on-per-page-change="onPerPageChange" @on-page-change="onPageChange" />
            <CommonModal ref="createCardModal" size="sm" :onHideOnlyX="true" @bHideModalHeaderClose="closeCreateCardModal">
                <template v-slot:CommonModalTitle>
                    {{ $t('create').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <b-form-group :label="$t('fob_number')">
                        <b-form-input v-model="fobNumber" :placeholder="$t('optional')" maxlength="100" />
                    </b-form-group>
                    <b-button variant="primary" block @click="confirmCreateCard">{{ $t('create') }}</b-button>
                </template>
            </CommonModal>
            <CommonModal ref="photoModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="closeModal">
                <template v-slot:CommonModalContent>
                    <div id="showCard">
                        <img v-if="asPrint" :src="cardPhotoF" style="width: 100%" />
                        <img v-if="asPrint" :src="cardPhotoB" style="width: 100%" />
                    </div>
                </template>
            </CommonModal>
            <CommonModal ref="openUploadCameraModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="closeCamera">
                <template v-slot:CommonModalTitle>
                    {{ $t('take_a_photo').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <div v-if="currentPhotoLoading" class="text-center mb-3">
                        <b-spinner small variant="primary" />
                    </div>
                    <div v-else-if="currentPhoto" class="text-center mb-3">
                        <img :src="currentPhoto" style="max-height: 150px; border-radius: 8px; object-fit: cover;" />
                    </div>
                    <camera-component
                        :open-camera.sync="isCameraOpen"
                        :upload-handler="handleUpload"
                        @camera-error="handleCameraError"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="uploadPhotoModal" :onHideOnlyX="true" @bHideModalHeaderClose="closeUploadImageModal">
                <template v-slot:CommonModalTitle>
                    {{ $t('upload_photo').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <div v-if="currentPhotoLoading" class="text-center mb-3">
                        <b-spinner small variant="primary" />
                    </div>
                    <div v-else-if="currentPhoto" class="text-center mb-3">
                        <img :src="currentPhoto" style="max-height: 150px; border-radius: 8px; object-fit: cover;" />
                    </div>
                    <b-form-group :label="$t('photo')" class="mb-2">
                        <div class="d-flex custom-file-upload mb-2">
                            <b-form-file
                                v-model="photoFile"
                                :placeholder="$t('select_file')"
                                :drop-placeholder="$t('drop_file')"
                                ref="fileInput"
                                accept="image/jpeg, image/png, image/gif"
                            >
                            </b-form-file>
                            <b-button  variant="outline-secondary"
                                       @click="$refs.fileInput.$el.childNodes[0].click();">
                                <i class="ri-add-fill"></i>
                            </b-button>
                        </div>
                    </b-form-group>
                    <b-button variant="primary" block  @click="handleUpload(photoFile)">{{ $t('upload') }}</b-button>
                </template>
            </CommonModal>
            <CommonModal ref="updateFobNumberModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="closeUpdateFobNumberModal">
                <template v-slot:CommonModalTitle>
                    {{ $t('update').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <b-form-group :label="$t('fob_number')">
                        <b-form-input v-model="fobNumber" maxlength="100" />
                    </b-form-group>

                    <b-button variant="primary" block @click="updateFobNumber">{{ $t('create') }}</b-button>
                </template>
            </CommonModal>
        </app-layout>
        <div id="printCard" v-show="false">
            <img v-if="asPrint" :src="cardPhotoP" style="width: 100%" />
        </div>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox";
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox";
import StudentCardStatusSelectbox from "@/components/interactive-fields/StudentCardStatusSelectbox";
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox";
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox";
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
import qs from "qs";
import CommonModal from "@/components/elements/CommonModal";
import toBase64 from "@/helpers/toBase64";
import StaffIdCardService from "@/services/StaffIdCardService";
import StaffService from "@/services/StaffService";
import CameraComponent from "@/components/interactive-fields/CameraComponent.vue";
import UnitService from "@/services/UnitService";

export default {
    components: {
        CameraComponent,
        SemestersSelectbox,
        AcademicYearsSelectbox,
        StudentCardStatusSelectbox,
        ProgramSelectbox,
        FacultySelectbox,
        ParameterSelectbox,
        CommonModal,

        Datatable,
        DatatableFilter,

        HeaderMobile,
        Header,

        AppLayout
    },
    data() {
        return {
            asPrint: null,
            cardPhotoF: null,
            cardPhotoB: null,
            cardPhotoP: null,
            datatable: {
                filterStatus: true,
                rows: [],
                columns: [
                    {
                        label: "",
                        field: 'buttons',
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t("create"),
                                class: 'ri-image-add-line align-middle top-minus-1 mr-3 text-muted',
                                permission:'staffcard_create',
                                callback: ({ id }) => {
                                    this.openCreateCardModal(id)
                                }
                            },
                            {
                                text: this.$t("download_front"),
                                class: 'ri-printer-line align-middle top-minus-1 mr-3 text-muted',
                                permission:'staffcard_print',
                                callback: ({ id }) => {
                                    this.printCard(id, "front")
                                }
                            },
                            {
                                text: this.$t("download_back"),
                                class: 'ri-printer-line align-middle top-minus-1 mr-3 text-muted',
                                permission:'staffcard_print',
                                callback: ({ id }) => {
                                    this.printCard(id, "back")
                                }
                            },
                            {
                                text: this.$t("take_a_photo"),
                                class: 'ri-camera-line font-size-base align-middle top-minus-1 mr-3 text-muted',
                                permission:'studentprogram_photoupload',
                                callback: ({user_id}) => {
                                    this.staffCardId=user_id
                                    this.openCamera()
                                }
                            },
                            {
                                text: this.$t("upload_photo"),
                                class: 'ri-upload-2-line font-size-base align-middle top-minus-1 mr-3 text-muted',
                                permission:'studentprogram_photoupload',
                                callback: ({user_id}) => {
                                    this.staffCardId=user_id
                                    this.uploadPhotoModalShow()
                                }
                            },
                            {
                                text: this.$t("update_fob_number"),
                                class: 'ri-edit-box-line font-size-base align-middle top-minus-1 mr-3 text-muted',
                                permission:'staffcard_fobnumber',
                                callback: (row) => {
                                    const fobs = row.fob_numbers || []
                                    this.fobNumber = fobs.length ? fobs[fobs.length - 1] : null
                                    this.cardId=row.id
                                    this.updateFobNumberModalShow()
                                }
                            },
                        ]
                    },
                    {
                        field: 'person.name',
                        label: this.toUpperCase("name"),
                        sortable: false,
                        hidden: false
                    },
                    {
                        field: 'person.surname',
                        label: this.toUpperCase('surname'),
                        sortable: false,
                        hidden: false
                    },
                    {
                        field: ("faculty_name"),
                        label: this.toUpperCase("faculty"),
                        sortable: false,
                        hidden: false
                    },
                    {
                        field: ("program_name"),
                        label: this.toUpperCase("program"),
                        sortable: false,
                        hidden: false
                    },

                    {
                        field: "card_status",
                        label: this.toUpperCase("card_status"),
                        sortable: false,
                        hidden: false
                    },
                ],
                queryParams: {
                    filter: {},
                    limit: 20,
                    page: 1,
                },
                total: 0,
                showTable: false,
                isLoading: false
            },
            staffCardId:null,
            cardId:null,
            createCardId:null,
            fobNumber:null,

            isCameraOpen:false,
            photoFile:null,
            currentPhoto:null,
            currentPhotoLoading:false,

        }
    },
    methods: {
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            let config = {
                params: { ...this.datatable.queryParams },
                paramsSerializer: (params) => {
                    return qs.stringify(params, { encode: false })
                }
            }

            StaffIdCardService.getAll(config).then(res => {
                this.datatable.rows = res.data.data;
                this.datatable.total = res.data.pagination.total
            }).finally(() => this.datatable.isLoading = false)
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows()
        },
        filterClear() {
            let filterArr = Object.keys(this.datatable.queryParams.filter)
            for (const val of filterArr) {
                this.datatable.queryParams.filter[val] = null
            }
            this.getRows()
        },
        openCreateCardModal(id) {
            this.createCardId = id;
            this.$refs.createCardModal.$refs.commonModal.show();
        },
        closeCreateCardModal() {
            this.$refs.createCardModal.$refs.commonModal.hide();
            this.createCardId = null;
        },
        async confirmCreateCard() {
            this.$refs.createCardModal.$refs.commonModal.hide();
            await this.previewStudentCard(this.createCardId, this.fobNumber);
            this.createCardId = null;
        },
        async previewStudentCard(id, fobNumber = null) {
            try {
                let dataF = await StaffIdCardService.createCard(id, "front", fobNumber)
                let dataB = await StaffIdCardService.createCard(id, "back", fobNumber)
                this.asPrint = true;
                this.cardPhotoF = toBase64(dataF);
                this.cardPhotoB = toBase64(dataB);
                this.$refs.photoModal.$refs.commonModal.show()
            } catch (err) {
                this.showErrors(err)
            }
        },
        async printCard(id, side) {
            try {
                if (!side) return
                let data = await StaffIdCardService.printCard(id, side);
                this._downloadFile(data,'student_cart_'+side+'.png')

                //
                // let b64=toBase64(data);
                // const winHtml = `
                //             <html>
                //                 <body style="margin:0; padding:0;">
                //                     <img src="${b64}" width="319" height="200">
                //                 </body>
                //             </html>`;
                //
                // const winUrl = URL.createObjectURL(
                //     new Blob([winHtml], { type: "text/html" })
                // );
                //
                // let x = screen.width / 2 - 165;
                // let y = screen.height / 2 - 150;
                // const win = window.open(
                //     winUrl,
                //     "Print",
                //     `width=330,height=300,screenX=${x},screenY=${y},resizable=no`
                // );
                //
                // win.focus(); // Yeni pencereyi odaklamak için
                // win.print(); // Pencerenin içeriğini yazdırmak için
            } catch (err) {
                this.showErrors(err);
            }
        },
        closeModal() {
            this.$refs.photoModal.$refs.commonModal.hide();
            this.asPrint = null;
            this.cardPhoto = null
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        async fetchCurrentPhoto(id) {
            this.currentPhotoLoading = true;
            this.currentPhoto = null;
            try {
                const response = await StaffService.personGetProfilePhoto(id);
                this.currentPhoto = toBase64(response);
            } catch {
                this.currentPhoto = null;
            } finally {
                this.currentPhotoLoading = false;
            }
        },
        closeCamera(){
            this.$refs.openUploadCameraModal.$refs.commonModal.hide()
            this.isCameraOpen = false;
            this.currentPhoto = null;
        },
        openCamera() {
            this.$refs.openUploadCameraModal.$refs.commonModal.show()
            this.isCameraOpen = true;
            this.fetchCurrentPhoto(this.staffCardId);
        },
        async handleUpload(file) {
            const formData = new FormData();
            formData.append('file', file)
            StaffService.personUploadPhoto(formData, this.staffCardId)
                .then(response => {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.closeCamera()
                    this.closeUploadImageModal()
                })
                .catch(e => {
                    this.showErrors(e);
                })
        },
        handleCameraError(error) {
            this.$toast.error('Could not open camera. Please check permissions.');
            this.isCameraOpen = false;
        },
        closeUploadImageModal(){
            this.photoFile=null
            this.currentPhoto = null;
            this.$refs.uploadPhotoModal.$refs.commonModal.hide()
        },
        uploadPhotoModalShow() {
            this.$refs.uploadPhotoModal.$refs.commonModal.show()
            this.fetchCurrentPhoto(this.staffCardId);
        },
        updateFobNumberModalShow() {
            this.$refs.updateFobNumberModal.$refs.commonModal.show()
        },
        closeUpdateFobNumberModal(){
            this.cardId=null
            this.fobNumber=null
            this.$refs.updateFobNumberModal.$refs.commonModal.hide()
        },
        updateFobNumber() {
            const formData = new FormData();
            formData.append('fob_number', this.fobNumber)
            StaffIdCardService.updateFobNumber(this.cardId, formData)
                .then((response) => {
                    this.$toast.success(this.$t('api.' + response.data.message))
                    this.$refs.updateFobNumberModal.$refs.commonModal.hide()
                    this.getRows()
                })
                .catch((error) => {
                    this.$toast.error(this.$t('api.' + error.data.message))
                })
        },
    }
}
</script>
<style>
:root {
    --srcOfBackground: '';
}

@media print {
    #printCard {
        background-image: var(--srcOfBackground);
    }
}

.fob-chip:hover {
    background-color: #e9ecef !important;
    border-color: #adb5bd !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05) !important;
}

.fob-chip:active {
    transform: translateY(0) !important;
}
</style>
